import Resource from './common/resource';

class Reports extends Resource {
  path = 'reports';
}

export default Reports;
